// extracted by mini-css-extract-plugin
module.exports = {"redirecting":"index_page_redirecting__EsN7v","spinner":"index_page_spinner__AzdvC"};